// extracted by mini-css-extract-plugin
module.exports = {"record":"_9a8a25a","progressBar":"_86846f5","limitValue":"_321bb1c","colorGreen":"_9995fbe","colorOrange":"_5b83eaa","colorRed":"_280620c"};